
// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/AsignarProfesorGrupo.css";

// // const API = process.env.REACT_APP_API || "http://localhost:5001/api/asignaciones-grupo";

// const API = process.env.REACT_APP_API || "http://3.236.217.225:5001/api/asignaciones-grupo";

// export default function AsignarProfesorGrupo() {

//   const { token } = useAuth();
//   const headers = { Authorization: `Bearer ${token}` };

//   const [tenantNombre, setTenantNombre] = useState("");

//   const [sedes, setSedes] = useState([]);
//   const [sedeId, setSedeId] = useState("tenant");

//   const [profesores, setProfesores] = useState([]);
//   const [materias, setMaterias] = useState([]);
//   const [grados, setGrados] = useState([]);
//   const [grupos, setGrupos] = useState([]);
//   const [asignaciones, setAsignaciones] = useState([]);

//   const [profesorId, setProfesorId] = useState("");
//   const [materiaId, setMateriaId] = useState("");
//   const [grado, setGrado] = useState("");
//   const [grupo, setGrupo] = useState("");

//   const [editando, setEditando] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [busqueda, setBusqueda] = useState("");

//   /* =========================
//      1️⃣ TENANT + SEDES
//   ========================= */
//   useEffect(() => {
//     if (!token) return;

//     const fetchData = async () => {
//       try {
//         const res = await axios.get(`${API}/tenant-info`, { headers });
//         setTenantNombre(res.data.tenant || "");
//         setSedes(res.data.sedes || []);
//       } catch (err) {
//         console.error("❌ Error tenant:", err);
//       }
//     };

//     fetchData();
//   }, [token]);

//   /* =========================
//      2️⃣ PROFESORES
//   ========================= */
//   useEffect(() => {
//     const fetch = async () => {
//       try {
//         const res = await axios.get(`${API}/profesores?sede_id=${sedeId}`, { headers });
//         setProfesores(res.data || []);
//       } catch (err) {
//         console.error("❌ profesores:", err);
//       }
//     };

//     fetch();
//   }, [sedeId]);

//   /* =========================
//      3️⃣ MATERIAS
//   ========================= */
//   useEffect(() => {
//     const fetch = async () => {
//       try {
//         const res = await axios.get(`${API}/materias`, { headers });
//         setMaterias(res.data || []);
//       } catch (err) {
//         console.error("❌ materias:", err);
//       }
//     };

//     fetch();
//   }, []);

//   /* =========================
//      4️⃣ DATOS
//   ========================= */
//   const cargarDatos = async () => {
//     try {
//       setLoading(true);

//       const [g, a] = await Promise.all([
//         axios.get(`${API}/grados?sede_id=${sedeId}`, { headers }),
//         axios.get(`${API}?sede_id=${sedeId}`, { headers })
//       ]);

//       setGrados(g.data || []);
//       setAsignaciones(a.data || []);

//       setGrado("");
//       setGrupo("");
//       setGrupos([]);

//     } catch (err) {
//       console.error("❌ datos:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     cargarDatos();
//   }, [sedeId]);

//   /* =========================
//      5️⃣ GRUPOS
//   ========================= */
//   useEffect(() => {
//     if (!grado) return;

//     const fetch = async () => {
//       try {
//         const res = await axios.get(`${API}/grupos/${grado}?sede_id=${sedeId}`, { headers });
//         setGrupos(res.data || []);
//       } catch (err) {
//         console.error("❌ grupos:", err);
//       }
//     };

//     fetch();
//   }, [grado, sedeId]);

//   /* =========================
//      6️⃣ GUARDAR
//   ========================= */
//   const handleGuardar = async () => {
//     if (!profesorId || !materiaId || !grado || !grupo) {
//       return alert("⚠️ Todos los campos son obligatorios");
//     }

//     try {
//       setLoading(true);

//       if (editando) {
//         await axios.put(
//           `${API}/${editando}`,
//           {
//             profesor_id: profesorId,
//             materia_id: materiaId,
//             grado,
//             grupo
//           },
//           { headers }
//         );
//         alert("✅ Actualizado");
//       } else {
//         await axios.post(
//           `${API}`,
//           {
//             profesor_id: profesorId,
//             materia_id: materiaId,
//             grado,
//             grupo,
//             sede_id: sedeId
//           },
//           { headers }
//         );
//         alert("✅ Creado");
//       }

//       resetForm();
//       await cargarDatos();

//     } catch (err) {
//       console.error("❌ guardar:", err);
//       alert(err.response?.data?.message || "Error guardando");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetForm = () => {
//     setEditando(null);
//     setProfesorId("");
//     setMateriaId("");
//     setGrado("");
//     setGrupo("");
//     setGrupos([]);
//   };

//   /* =========================
//      ✏️ EDITAR
//   ========================= */
//   const iniciarEdicion = (a) => {
//     setEditando(a.id);
//     setProfesorId(a.profesor_id);
//     setMateriaId(a.materia_id);
//     setGrado(a.grado);
//     setGrupo(a.grupo);
//   };

//   /* =========================
//      🗑️ ELIMINAR
//   ========================= */
//   const eliminar = async (id) => {
//     if (!window.confirm("¿Eliminar asignación?")) return;

//     try {
//       await axios.delete(`${API}/${id}`, { headers });
//       await cargarDatos();
//     } catch (err) {
//       alert("Error eliminando");
//     }
//   };

//   /* =========================
//      🔍 FILTRO
//   ========================= */
//   const asignacionesFiltradas = asignaciones.filter(a =>
//     `${a.grado} ${a.grupo} ${a.materia} ${a.profesor}`
//       .toLowerCase()
//       .includes(busqueda.toLowerCase())
//   );

// return (
//   <div className="asignaciones-container">

//     {/* 🔍 BUSCADOR ARRIBA */}
//     <div className="asignaciones-header">
//       <h2>{tenantNombre}</h2>

//       <input
//         className="search-input"
//         placeholder="🔍 Buscar asignaciones..."
//         value={busqueda}
//         onChange={(e) => setBusqueda(e.target.value)}
//       />
//     </div>

//     {/* ⚙️ FORMULARIO CON NOMBRES */}
//     <div className="asignacion-card">

//       <div className="campo">
//         <label>Sede</label>
//         <select value={sedeId} onChange={e => setSedeId(e.target.value)}>
//           <option value="tenant">Sede Principal</option>
//           {sedes.map(s => (
//             <option key={s.id} value={s.id}>{s.nombre}</option>
//           ))}
//         </select>
//       </div>

//       <div className="campo">
//         <label>Profesor</label>
//         <select value={profesorId} onChange={e => setProfesorId(e.target.value)}>
//           <option value="">Seleccionar</option>
//           {profesores.map(p => (
//             <option key={p.id} value={p.id}>
//               {p.nombre} {p.apellido}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div className="campo">
//         <label>Materia</label>
//         <select value={materiaId} onChange={e => setMateriaId(e.target.value)}>
//           <option value="">Seleccionar</option>
//           {materias.map(m => (
//             <option key={m.id} value={m.id}>{m.nombre}</option>
//           ))}
//         </select>
//       </div>

//       <div className="campo">
//         <label>Grado</label>
//         <select value={grado} onChange={e => setGrado(e.target.value)}>
//           <option value="">Seleccionar</option>
//           {grados.map(g => (
//             <option key={g} value={g}>{g}</option>
//           ))}
//         </select>
//       </div>

//       <div className="campo">
//         <label>Grupo</label>
//         <select value={grupo} onChange={e => setGrupo(e.target.value)}>
//           <option value="">Seleccionar</option>
//           {grupos.map(g => (
//             <option key={g} value={g}>{g}</option>
//           ))}
//         </select>
//       </div>

//       <button className="btn-guardar" onClick={handleGuardar}>
//         {editando ? "Actualizar" : "Asignar"}
//       </button>

//     </div>

//     {/* 📋 LISTA (SIN TABLA) */}
//     <div className="lista-asignaciones">

//       {asignacionesFiltradas.map(a => (
//         <div key={a.id} className="card-asignacion">

//           <p><strong>Grado:</strong> {a.grado}</p>
//           <p><strong>Grupo:</strong> {a.grupo}</p>
//           <p><strong>Materia:</strong> {a.materia}</p>
//           <p><strong>Profesor:</strong> {a.profesor}</p>

//           <div className="acciones">
//             <button onClick={() => iniciarEdicion(a)}>✏️ Editar</button>
//             <button onClick={() => eliminar(a.id)}>🗑️ Eliminar</button>
//           </div>

//         </div>
//       ))}

//     </div>

//   </div>
// );


// }


//

import React, { useEffect, useState, useCallback } from "react";

import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import "../../style/AsignarProfesorGrupo.css";

export default function AsignarProfesorGrupo() {
  const { token, user } = useAuth();
  
  // 2. Headers dinámicos para Multitenancy
  const headers = { 
    Authorization: `Bearer ${token}`,
    "x-tenant-id": user?.tenant_id,
    "x-sede-id": user?.sede_id
  };

  const [tenantNombre, setTenantNombre] = useState("");
  const [sedes, setSedes] = useState([]);
  const [sedeId, setSedeId] = useState(user?.sede_id || "tenant");

  const [profesores, setProfesores] = useState([]);
  const [materias, setMaterias] = useState([]);
  const [grados, setGrados] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [asignaciones, setAsignaciones] = useState([]);

  const [profesorId, setProfesorId] = useState("");
  const [materiaId, setMateriaId] = useState("");
  const [grado, setGrado] = useState("");
  const [grupo, setGrupo] = useState("");

  const [editando, setEditando] = useState(null);
  const [loading, setLoading] = useState(false);
  const [busqueda, setBusqueda] = useState("");

  /* =========================
      1️⃣ TENANT + SEDES
  ========================= */
  useEffect(() => {
    if (!token) return;
    const fetchData = async () => {
      try {
        // CORREGIDO: Ruta relativa
        const res = await axios.get("/asignaciones-grupo/tenant-info", { headers });
        setTenantNombre(res.data.tenant || "");
        setSedes(res.data.sedes || []);
      } catch (err) {
        console.error("❌ Error tenant:", err);
      }
    };
    fetchData();
  }, [token]);

  /* =========================
      2️⃣ PROFESORES Y MATERIAS
  ========================= */
  useEffect(() => {
    if (!token) return;
    const fetchBase = async () => {
      try {
        const [profRes, matRes] = await Promise.all([
          axios.get(`/asignaciones-grupo/profesores?sede_id=${sedeId}`, { headers }),
          axios.get("/asignaciones-grupo/materias", { headers })
        ]);
        setProfesores(profRes.data || []);
        setMaterias(matRes.data || []);
      } catch (err) {
        console.error("❌ Error base data:", err);
      }
    };
    fetchBase();
  }, [sedeId, token]);

  /* =========================
      3️⃣ GRADOS Y ASIGNACIONES
  ========================= */
  const cargarDatos = useCallback(async () => {
    try {
      setLoading(true);
      const [g, a] = await Promise.all([
        axios.get(`/asignaciones-grupo/grados?sede_id=${sedeId}`, { headers }),
        axios.get(`/asignaciones-grupo?sede_id=${sedeId}`, { headers })
      ]);
      setGrados(g.data || []);
      setAsignaciones(a.data || []);
    } catch (err) {
      console.error("❌ Error cargando datos:", err);
    } finally {
      setLoading(false);
    }
  }, [sedeId, token]);

  useEffect(() => {
    cargarDatos();
  }, [cargarDatos]);

  /* =========================
      4️⃣ GRUPOS DINÁMICOS
  ========================= */
  useEffect(() => {
    if (!grado) {
      setGrupos([]);
      return;
    }
    const fetchGrupos = async () => {
      try {
        const res = await axios.get(`/asignaciones-grupo/grupos/${grado}?sede_id=${sedeId}`, { headers });
        setGrupos(res.data || []);
      } catch (err) {
        console.error("❌ Error grupos:", err);
      }
    };
    fetchGrupos();
  }, [grado, sedeId]);

  /* =========================
      5️⃣ GUARDAR / EDITAR
  ========================= */
  const handleGuardar = async () => {
    if (!profesorId || !materiaId || !grado || !grupo) {
      return alert("⚠️ Todos los campos son obligatorios");
    }

    try {
      setLoading(true);
      const payload = {
        profesor_id: profesorId,
        materia_id: materiaId,
        grado,
        grupo,
        sede_id: sedeId
      };

      if (editando) {
        await axios.put(`/asignaciones-grupo/${editando}`, payload, { headers });
        alert("✅ Asignación actualizada");
      } else {
        await axios.post("/asignaciones-grupo", payload, { headers });
        alert("✅ Asignación creada");
      }

      resetForm();
      cargarDatos();
    } catch (err) {
      alert(err.response?.data?.message || "Error al procesar la solicitud");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setEditando(null);
    setProfesorId("");
    setMateriaId("");
    setGrado("");
    setGrupo("");
    setGrupos([]);
  };

  const eliminar = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar esta asignación?")) return;
    try {
      await axios.delete(`/asignaciones-grupo/${id}`, { headers });
      cargarDatos();
    } catch (err) {
      alert("No se pudo eliminar la asignación");
    }
  };

  /* =========================
      🔍 FILTRO DE BÚSQUEDA
  ========================= */
  const asignacionesFiltradas = asignaciones.filter(a =>
    `${a.grado} ${a.grupo} ${a.materia} ${a.profesor}`
      .toLowerCase()
      .includes(busqueda.toLowerCase())
  );

  return (
    <div className="asignaciones-container">
      <div className="asignaciones-header">
        <h2 className="tenant-title">{tenantNombre || "Administración Escolar"}</h2>
        <div className="search-box">
          <input
            className="search-input"
            placeholder="🔍 Buscar por materia, profesor o grado..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>
      </div>

      <div className="asignacion-card main-form">
        <h3>{editando ? "✏️ Editar Asignación" : "➕ Nueva Asignación"}</h3>
        
        <div className="form-grid">
          <div className="campo">
            <label>Sede Destino</label>
            <select value={sedeId} onChange={e => setSedeId(e.target.value)}>
              <option value="tenant">Sede Principal</option>
              {sedes.map(s => (
                <option key={s.id} value={s.id}>{s.nombre}</option>
              ))}
            </select>
          </div>

          <div className="campo">
            <label>Profesor</label>
            <select value={profesorId} onChange={e => setProfesorId(e.target.value)}>
              <option value="">-- Seleccionar Docente --</option>
              {profesores.map(p => (
                <option key={p.id} value={p.id}>{p.nombre} {p.apellido}</option>
              ))}
            </select>
          </div>

          <div className="campo">
            <label>Materia</label>
            <select value={materiaId} onChange={e => setMateriaId(e.target.value)}>
              <option value="">-- Seleccionar Materia --</option>
              {materias.map(m => (
                <option key={m.id} value={m.id}>{m.nombre}</option>
              ))}
            </select>
          </div>

          <div className="campo">
            <label>Grado</label>
            <select value={grado} onChange={e => setGrado(e.target.value)}>
              <option value="">-- Seleccionar --</option>
              {grados.map(g => (
                <option key={g} value={g}>{g}</option>
              ))}
            </select>
          </div>

          <div className="campo">
            <label>Grupo</label>
            <select value={grupo} onChange={e => setGrupo(e.target.value)} disabled={!grupos.length}>
              <option value="">-- Seleccionar --</option>
              {grupos.map(g => (
                <option key={g} value={g}>{g}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-actions">
          <button className="btn-guardar" onClick={handleGuardar} disabled={loading}>
            {loading ? "Procesando..." : editando ? "Guardar Cambios" : "Confirmar Asignación"}
          </button>
          {editando && <button className="btn-cancelar" onClick={resetForm}>Cancelar</button>}
        </div>
      </div>

      <div className="lista-asignaciones">
        <h3>Registros en {sedeId === "tenant" ? "Sede Principal" : "Sede Seleccionada"}</h3>
        <div className="grid-cards">
          {asignacionesFiltradas.length > 0 ? (
            asignacionesFiltradas.map(a => (
              <div key={a.id} className="card-asignacion">
                <div className="card-info">
                  <span className="badge-grado">{a.grado}° - {a.grupo}</span>
                  <p><strong>Materia:</strong> {a.materia}</p>
                  <p><strong>Profesor:</strong> {a.profesor}</p>
                </div>
                <div className="acciones">
                  <button className="btn-edit" onClick={() => {
                      setEditando(a.id);
                      setProfesorId(a.profesor_id);
                      setMateriaId(a.materia_id);
                      setGrado(a.grado);
                      setGrupo(a.grupo);
                  }}>✏️</button>
                  <button className="btn-delete" onClick={() => eliminar(a.id)}>🗑️</button>
                </div>
              </div>
            ))
          ) : (
            <p className="no-results">No se encontraron asignaciones.</p>
          )}
        </div>
      </div>
    </div>
  );
}